import { render, staticRenderFns } from "./TheFilteredArticles.vue?vue&type=template&id=25326b78&scoped=true&"
import script from "./TheFilteredArticles.vue?vue&type=script&lang=js&"
export * from "./TheFilteredArticles.vue?vue&type=script&lang=js&"
import style0 from "./TheFilteredArticles.vue?vue&type=style&index=0&id=25326b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25326b78",
  null
  
)

export default component.exports